import React from 'react';
import { Draggable } from "react-beautiful-dnd";
import { Paper, Tooltip, Avatar, Divider } from "@mui/material";
import { Flex } from "../../style";
import NotesIcon from '@mui/icons-material/Notes';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { TfiClip } from "react-icons/tfi";
import ChecklistIcon from '@mui/icons-material/Checklist';
import config from '../../config';
import './Card.css';
import { getAvatarUrl } from '../../utils/getAvatarUrl';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function Card({
  card,
  index,
  coverColor,
  coverImage,
  openModal,
  tagsInCards,
  commentsCount,
  archivesCount,
  progressTasks,
  usersInCards
}) {
  const backendIp = config.backend_ip;

  return (
    <Draggable draggableId={`card-${card.id || card.card_id}`} index={index} key={`card-${card.id || card.card_id}`}>
      {(provided, snapshot) => (
        <div style={{ marginBottom: 10, cursor: 'grab' }}>
          <Paper
            elevation={2}
            {...provided.dragHandleProps}
            {...provided.draggableProps}
            ref={provided.innerRef}
            onClick={() => openModal(card)}
            style={{
              height: 'fit-content',
              padding: 10,
              borderRadius: '10px',
              ...provided.draggableProps.style,
            }}
            className='text-card card-background'
          >
            <Flex style={{ marginBottom: '5px' }}>
              {!snapshot.isDragging && tagsInCards.map((tag) => {
                return (
                  card.id === tag.card_id && (
                    <div
                      key={tag.id}
                      style={{
                        backgroundColor: tag.color_hex,
                        width: '35px',
                        height: '7px',
                        marginBottom: '5px',
                        borderRadius: '5px',
                      }}
                    ></div>
                  )
                );
              })}
            </Flex>
            {!snapshot.isDragging && coverColor.map((color) => {
              return (
                card.id === color.in_card_id && (
                  <div
                    onClick={() => openModal(card)}
                    {...provided.dragHandleProps}
                    {...provided.draggableProps}
                    style={{ ...provided.draggableProps.style, backgroundColor: color.hex_in_card, height: '80px', marginBottom: '5px', borderRadius: '10px', marginBottom: '-3px' }}>
                  </div>
                )
              )
            })}
            {!snapshot.isDragging && coverImage.map((image) => {
              return (
                card.id === image.card_id && (
                  <div
                    onClick={() => openModal(card)}
                    {...provided.dragHandleProps}
                    {...provided.draggableProps}
                    style={{
                      ...provided.draggableProps.style,
                      backgroundImage: `url('${backendIp}/api/board/ti/get_image/${image.image_id}')`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      height: '80px',
                      marginBottom: '5px',
                      borderRadius: '10px',
                      marginBottom: '-1px'
                    }}
                  ></div>
                )
              )
            })}
            <div style={{ maxWidth: '240px', overflowWrap: 'anywhere', marginTop: '10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              {card.completed && (
                <CheckCircleIcon className='text-card-icons' style={{ fontSize: '16px', color: 'green', marginLeft: '4px' }} />
              )}
              <p className='text-card' style={{ fontSize: '16px', margin: '0' }}>{card.title}</p>
            </div>
            <Flex
              style={{
                marginTop: '7px',
                marginLeft: '2px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline',
                flexWrap: 'wrap',
              }}
            >
              <Flex style={{ marginTop: '15px', flexShrink: 0 }}>
                {card.description && <NotesIcon className='text-card-icons' style={{ fontSize: '15px' }} />}
                {commentsCount.map((count) => {
                  return (
                    card.id === count.card_id && (
                      <Flex key={count.card_id} style={{ gap: '5px' }}>
                        <ChatBubbleOutlineIcon className='text-card-icons' style={{ fontSize: '15px' }} />
                        <p
                          style={{
                            fontSize: '11px',
                            marginTop: '0px',
                            marginBottom: '0px',
                          }}
                          className='text-card-icons'
                        >
                          {count.comments_by_card_id}
                        </p>
                      </Flex>
                    )
                  );
                })}
                {archivesCount.map((archiveCount) => {
                  return (
                    card.id === archiveCount.card_id && (
                      <Flex key={archiveCount.card_id} style={{ gap: '5px' }}>
                        <TfiClip className='text-card-icons' style={{ fontSize: '15px' }} />
                        <p
                          style={{
                            fontSize: '11px',
                            marginTop: '0px',
                            marginBottom: '0px',
                          }}
                          className='text-card-icons'
                        >
                          {archiveCount.archives_by_card_id}
                        </p>
                      </Flex>
                    )
                  );
                })}
                {progressTasks.map((progress) => {
                  return (
                    card.id === progress.card_id && (
                      <Flex key={progress.card_id} style={{ justifyContent: 'space-around' }}>
                        <ChecklistIcon className='text-card-icons' style={{ fontSize: '16px' }} />
                        <p
                          style={{
                            fontSize: '12px',
                            marginTop: '0px',
                            marginBottom: '0px',
                            position: 'relative',
                            right: '7px',
                          }}
                          className='text-card-icons'
                        >
                          {progress.completed_tasks}/{progress.total_tasks}
                        </p>
                      </Flex>
                    )
                  );
                })}
              </Flex>
              {/* <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', marginTop: '5px' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 5H6C4.89543 5 4 5.89543 4 7V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V7C20 5.89543 19.1046 5 18 5Z" stroke="#6D798E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M16 3V7" stroke="#6D798E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8 3V7" stroke="#6D798E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M4 11H20" stroke="#6D798E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11 15H12" stroke="#6D798E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12 15V18" stroke="#6D798E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <p className='text-date'>JAN 20, 2025</p>
              </div> */}
              <Flex
                style={{
                  maxWidth: '200px',
                  flexWrap: 'wrap',
                  flexShrink: 0,
                  marginLeft: 'auto',
                  flexDirection: 'row-reverse',
                }}
              >
                {usersInCards.map((user) => {
                  return (
                    card.id === user.user_card_id && (
                      <Tooltip
                        key={user.user_in_card.toString()}
                        title={user.user_in_card || 'Sem nome'}
                        PopperProps={{
                          modifiers: [
                            {
                              name: 'offset',
                              options: {
                                offset: [0, -10],
                              },
                            },
                          ],
                        }}
                      >
                        <Avatar
                          className="comment-avatar-card"
                          src={getAvatarUrl(user.user_in_card)}
                        />
                      </Tooltip>
                    )
                  );
                })}
              </Flex>
            </Flex>
          </Paper>
        </div>
      )}
    </Draggable>
  );
}

export default Card;
